import styled from "styled-components";

export const Wrap = styled.div`
  display: flex;

  @media (max-width: 576px) {
    flex-direction: column;
  }
`;
